import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationCancel, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { filter } from 'rxjs/operators';
import { LocalService } from './services/local.service';
import { CustomerService } from './services/customer.service';
import { AmazonService } from './services/amazon.service';
import { ToastrService } from 'ngx-toastr';
import { AdminUserService } from './services/admin/user.service';
declare let $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ]
})
export class AppComponent implements OnInit, OnDestroy {
    title = 'lemonmode-ng';
    location: any;
    routerSubscription: any;
    isSuperAdmin: any = false;
    isShow: any = false;
    isAdminShow: any = false;
    isShowFooter: boolean = true;
    isShowNavigation: boolean = false;
    routeArray = [
        '/customer/order-file',
        '/customer/dashboard',
        '/admin/dashboard',
        '/admin/orders-file',
        '/customer/orders',
        '/admin/contact-list',
        '/admin/marketplace-flow',
        '/admin/shipment-status',
        '/admin/subscription-plan',
        '/admin/carrier-company-configuration',
        '/admin/email-configuration',
        '/admin/master-data',
        '/admin/customer-details',
        '/admin/orders',
    ];
    constructor(
        private router: Router,
        private _localService: LocalService,
        private _loginService: CustomerService,
        private _amazonService: AmazonService,
        private toaster: ToastrService,
        private _adminLoginService: AdminUserService,
        private route: ActivatedRoute,
        private _changeDetectorRef: ChangeDetectorRef
    ) {
    }

    ngOnInit(): void {
        document.body.classList.add('preloader-active');
        document.body.classList.remove('page-ready');

        this._localService.isShowNavigation.subscribe((res) => {
            // res ? this.isShowNavigation = true : this.isShowNavigation = false;
            this.isShowNavigation = res ? true : false;
        });
        this._loginService.isLogin.subscribe((res) => {
            this.isShow = res && this.isCustomerRoute(this.router.url);
            this._changeDetectorRef.markForCheck();
        });
        this._adminLoginService.isLogin.subscribe((resAd) => {
            this.isAdminShow = resAd && this.isAdminRoute(this.router.url);
            this._changeDetectorRef.markForCheck();
        });
        this.router.events.subscribe(
            (event: any) => {
                if (event instanceof NavigationEnd)
                {
                    if (event.url.startsWith('/admin/customer-details/'))
                    {
                        const dynamicId = event.url.split('/').pop(); // Extract dynamic ID from the URL
                        if (dynamicId)
                        {
                            // Remove the old URL with the previous dynamic ID from routeArray, if it exists
                            const oldUrlIndex = this.routeArray.findIndex(url => url.includes('/admin/customer-details/'));
                            if (oldUrlIndex !== -1)
                            {
                                this.routeArray.splice(oldUrlIndex, 1);
                            }

                            // Add the new URL with the current dynamic ID to routeArray
                            const newUrl = event.url;
                            this.routeArray.push(newUrl);
                        }
                    }
                    const activeUrl = (event.urlAfterRedirects || event.url || '').split('?')[0].replace(/\/+$/, '') || '/';
                    const isCustomerRoute = activeUrl.startsWith('/customer');
                    const isAdminRoute = activeUrl.startsWith('/admin') && activeUrl !== '/admin';

                    if (isCustomerRoute || isAdminRoute)
                    {
                        this.isShow = isCustomerRoute && this._loginService.isLogin.getValue();
                        this.isAdminShow = isAdminRoute && this._adminLoginService.isLogin.getValue();
                        this.isShowFooter = false;
                    } else
                    {
                        if (event.url === '/documentation')
                        {
                            this.isShowFooter = false;
                        } else
                        {
                            this.isShowFooter = true;
                        }
                        this.isShow = false;
                        this.isAdminShow = false;
                    }
                    this._changeDetectorRef.markForCheck();
                }
            }
        );

        this.recallJsFuntions();
        const localStorage_data = this._localService.getJsonValue('user');
        const adminStorageData = this._localService.getJsonValue('adminUser');
        const adminToken = this._localService.getJsonValue('adminToken');
        if (adminStorageData && adminToken)
        {
            this._adminLoginService.isLogin.next(true);
        }
        if (localStorage_data)
        {
            this.isSuperAdmin = localStorage_data.isSuperAdmin;
            this._loginService.isLogin.next(true);
            this.route.queryParams
                .subscribe((paramsArg) => {
                    const { tracking_number, ...params } = paramsArg;
                    if (Object.keys(params).length > 0)
                    {
                        this._amazonService.exchangeLWAAuthorizationCode({ ...params, customer_id: localStorage_data._id, customer_email: localStorage_data.email }).subscribe({
                            next: (payload: any) => {

                            },
                            error: ({ error }) => {
                                this.toaster.error(error ? error.message : 'Something went wrong.', '');
                            },
                        });
                    }
                }
                );
        }
    }

    ngOnDestroy(): void {
        // Unsubscribe from the routerSubscription to prevent memory leaks
        if (this.routerSubscription)
        {
            this.routerSubscription.unsubscribe();
        }

        document.body.classList.remove('preloader-active');
        document.body.classList.remove('page-ready');
    }

    recallJsFuntions(): void {
        // NO preloader for any routes - smooth navigation everywhere
        this.routerSubscription = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
            .subscribe((event: any) => {
                const currentUrl = event.url || '';

                // Always hide preloader and scroll to top
                this.location = this.router.url;
                window.scrollTo(0, 0);
                document.body.classList.remove('preloader-active');
                document.body.classList.add('page-ready');
                $('.preloader').hide();
            });
    }

    private isCustomerRoute(url: string): boolean {
        const activeUrl = (url || '').split('?')[0].replace(/\/+$/, '') || '/';
        return activeUrl.startsWith('/customer');
    }

    private isAdminRoute(url: string): boolean {
        const activeUrl = (url || '').split('?')[0].replace(/\/+$/, '') || '/';
        return activeUrl.startsWith('/admin') && activeUrl !== '/admin';
    }
}
